import type { QueryClient } from "@tanstack/react-query";
import {
  buildDashboardWidgetSettings,
  normalizeWidgetSettingsPayload,
} from "@/lib/dashboard/widget-setting-model";
import { fetchWidgetSettings } from "@/lib/dashboard/widgets-client";
import type { DashboardWidgetSettings } from "@/lib/types/dashboard-widgets";
import { QueryKeys } from "@/lib/types";

export async function prefetchWidgetSettings(
  queryClient: QueryClient,
  tenantId: number,
  accessToken: string,
): Promise<DashboardWidgetSettings> {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.WidgetSettings, tenantId],
    queryFn: async () => {
      const raw = await fetchWidgetSettings(accessToken, tenantId);
      return normalizeWidgetSettingsPayload(raw);
    },
  });

  const normalized =
    queryClient.getQueryData<Awaited<ReturnType<typeof normalizeWidgetSettingsPayload>>>([
      QueryKeys.WidgetSettings,
      tenantId,
    ]) ?? [];

  return buildDashboardWidgetSettings(normalized);
}
